// extracted by mini-css-extract-plugin
export var infoItem = "_r1-2";
export var title = "_r1-0";
export var value = "_r1-1";